define('meeting-id',['require','knockout'],function (require) {
    var ko = require('knockout');

    /**
     * Format meeting id
     * i.e. 123123123 => 123-123-123
     */
    ko.bindingHandlers.meetingId = {
        update: function (element, valueAccessor) {
            var meetingId = ko.isObservable(valueAccessor) ?
                ko.utils.unwrapObservable(valueAccessor()) : valueAccessor();
            var formattedId = String((meetingId || '')).replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');

            ko.bindingHandlers.text.update(element, function () {
                return formattedId;
            });
        }
    };
});

